import Typography from "ds/components/Typography";

const TaxDisclaimer = () => {
  return (
    <Typography tag="p" variant="p-body4" color="secondary">
      All prices displayed are exclusive of taxes. Applicable taxes will be calculated and added
      based on the customer's jurisdiction and applicable law at checkout.
    </Typography>
  );
};

export default TaxDisclaimer;
